import { z } from 'zod';

export const TokenUsageEntrySchema = z.object({
  id: z.string().guid(),
  createdAt: z.string().datetime(),
  userId: z.string().guid().nullable(),
  organizationId: z.string().guid(),
  hotelId: z.string().guid().nullable(),
  monthlyPlanId: z.string().guid().nullable(),
  postId: z.string().guid().nullable(),
  taskKind: z.string(),
  provider: z.string(),
  model: z.string(),
  logicalModel: z.string(),
  inputTokens: z.number().int().nonnegative(),
  outputTokens: z.number().int().nonnegative(),
  cachedTokens: z.number().int().nonnegative(),
  costUsd: z.number().nonnegative(),
  latencyMs: z.number().int().nonnegative().nullable(),
});
export type TokenUsageEntry = z.infer<typeof TokenUsageEntrySchema>;

export const TokenUsageQuerySchema = z.object({
  hotelId: z.string().guid().optional(),
  from: z.string().datetime().optional(),
  to: z.string().datetime().optional(),
  bucket: z.enum(['day', 'week', 'month']).default('day'),
});
export type TokenUsageQuery = z.infer<typeof TokenUsageQuerySchema>;

export const TokenUsageBucketSchema = z.object({
  bucket: z.string(),
  inputTokens: z.number().int(),
  outputTokens: z.number().int(),
  cachedTokens: z.number().int(),
  costUsd: z.number(),
  callCount: z.number().int(),
});
export type TokenUsageBucket = z.infer<typeof TokenUsageBucketSchema>;

export const TokenUsageSummarySchema = z.object({
  totalCostUsd: z.number(),
  totalCalls: z.number().int(),
  totalInputTokens: z.number().int(),
  totalOutputTokens: z.number().int(),
  totalCachedTokens: z.number().int(),
  cacheHitRate: z.number(),
  byModel: z.array(
    z.object({
      logicalModel: z.string(),
      model: z.string(),
      callCount: z.number().int(),
      costUsd: z.number(),
    }),
  ),
  byHotel: z.array(
    z.object({
      hotelId: z.string().guid().nullable(),
      hotelName: z.string().nullable(),
      callCount: z.number().int(),
      costUsd: z.number(),
    }),
  ),
  buckets: z.array(TokenUsageBucketSchema),
});
export type TokenUsageSummary = z.infer<typeof TokenUsageSummarySchema>;
